<div class="placeholder-card d-flex flex-column align-items-center justify-content-center text-center p-5">
  <p class="fs-20 fw-800 color-gray-950 mb-1">{{titleKey|translate}}</p>
  <p class="fs-normal fw-400 color-gray-400 mb-0">{{'labels.coming_soon'|translate}}</p>
</div>
